// extracted by mini-css-extract-plugin
export var chevronIcon = "_4g-2";
export var teamName = "_4g-1";
export var teamSwitcherButton = "_4g-0";